<h3 mat-dialog-title>Cannot Delete Bank Account</h3>

<mat-dialog-content>
    <p>
        {{data.account.friendlyName}} is your last deposit account. You must have at least one deposit account on file to make use of the
        site's features.
    </p>
    <p>
        Removing your last deposit account would leave nowhere for your users' payments to go. If you wish to
        cancel your account with us, please contact our Support Team.
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>Ok</button>
</mat-dialog-actions>
